import { useAppSelector } from 'store/hooks';
import { selectContactsInOrder, selectSections } from '../selectors';
const EMPTY_ARRAY = [];
export const useMapToSections = (searchFilter, remoteContacts) => useAppSelector((state) => selectSections(state, searchFilter, remoteContacts)) || EMPTY_ARRAY;
export const useContactsInOrder = (searchFilter) => useAppSelector((state) => selectContactsInOrder(state, searchFilter)) || EMPTY_ARRAY;
